import React, { useEffect } from "react";
import { Text, Container, Loader } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useAuthProfile } from "../../utils/useAuthProfile";

type Props = {
  message?: string;
};

const NotFound: React.FC<Props> = ({ message }) => {
  const navigate = useNavigate();
  const [userProfile, ,] = useAuthProfile();

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      if (userProfile) {
        navigate("/");
      } else {
        navigate("/login");
      }
    }, 3500);

    return () => {
      // 👇️ clear timeout when the component unmounts
      clearTimeout(timeoutID);
    };
  }, []);

  return (
    <Container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      <Text
        style={{
          fontFamily: `Greycliff CF, Inter`,
          textAlign: "center",
          fontSize: "20px",
          width: "680px",
        }}
      >
        {message ||
          "The link or resource you are trying to access does not exist."}
      </Text>
      <Text size="sm" mt={16}>
        You will be redirected shortly
        <Loader variant="dots" ml={2} size="sm" />
      </Text>
    </Container>
  );
};

export default NotFound;
